import { Badge } from "primereact/badge"

import "../style.scss"

const NotificationsByDayDate = ({ date }: $TSMigrationFixMe) => {
  return (
    <div className='notifications-list-by-month-date w-100 d-flex justify-content-end mb-3 mt-2'>
      <div className='notifications-list-by-month-date-label mr-2'>{date}</div>
      <Badge className='notifications-list-by-month-date-icon my-auto' />
    </div>
  )
}

export default NotificationsByDayDate
